'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialPinterestCircular = function TiSocialPinterestCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 35c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z m0-26.7c-6.4 0-11.7 5.3-11.7 11.7s5.3 11.7 11.7 11.7 11.7-5.3 11.7-11.7-5.3-11.7-11.7-11.7z m0.6 5c-4.2 0-6.2 3-6.2 5.4 0 1.5 0.5 2.9 1.7 3.3 0.2 0.1 0.4 0.1 0.5-0.2 0-0.1 0.1-0.5 0.2-0.7 0-0.2 0-0.3-0.2-0.4-0.3-0.5-0.5-1-0.5-1.7 0-2.2 1.6-4.2 4.2-4.2 2.3 0 3.6 1.4 3.6 3.3 0 2.5-1.1 4.6-2.7 4.6-0.9 0-1.6-0.7-1.4-1.6 0.3-1.1 0.8-2.3 0.8-3.1 0-0.7-0.4-1.3-1.2-1.3-0.9 0-1.7 0.9-1.7 2.2 0 0.8 0.3 1.4 0.3 1.4l-1.1 4.7c-0.3 1.4 0 3.1 0 3.3 0 0.1 0.1 0.1 0.2 0.1 0.1-0.2 1.2-1.5 1.5-2.9 0.2-0.4 0.7-2.4 0.7-2.4 0.3 0.6 1.1 1.1 2.1 1.1 2.8 0 4.6-2.5 4.6-5.9 0-2.6-2.1-5-5.4-5z' })
        )
    );
};

exports.default = TiSocialPinterestCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-pinterest-circular.js
// module id = 2185
// module chunks = 0